/* @flow */
import React from 'react';
import Input from 'components/Input.jsx';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import Button from 'components/Button.jsx';
import Hovercard from 'components/Hovercard.jsx';
import { Picker, Uploader } from 'components/File';
import HoverLayerTrigger from 'components/HoverLayerTrigger.jsx';

import './styles/ContentSourceProviderProfilePictureInput.scss';

type Props = {
  onChange: Function,
  placeholder?: ?string,
  defaultValue?: ?string,
};

type State = {
  key: number,
  value?: ?string,
};

class ContentSourceProviderProfilePictureInput extends React.Component<Props, State> {
  state: State = {
    key: 1,
  };

  componentDidMount() {
    this.setState({ value: this.props.defaultValue }); // eslint-disable-line react/no-did-mount-set-state
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.value !== undefined && prevState.value !== this.state.value) {
      this.props.onChange({ target: { value: this.state.value } });
    }
  }

  clear = () => {
    this.setState({ value: null, key: this.state.key + 1 });
  };

  handleUploadSuccess = (data: *) => {
    this.setState({ value: data.url });
  };

  renderPreview(url: string) {
    return (
      <div className="ContentSourceProviderProfilePictureInput-preview">
        <Glyph
          name="close"
          size="xxxsmall"
          onClick={this.clear}
          className="ContentSourceProviderProfilePictureInput-preview-closeIcon"
        />
        <HoverLayerTrigger
          placement="bottom"
          layer={
            <Hovercard className="ContentSourceProviderProfilePictureInput-preview-card">
              <Image height={150} width={150} src={url} />
            </Hovercard>
          }>
          <Input disabled value={url} />
        </HoverLayerTrigger>
      </div>
    );
  }

  render() {
    return (
      <Picker key={this.state.key}>
        {({ pick, file }) => {
          if (this.state.value) {
            return this.renderPreview(this.state.value);
          }

          if (!file) {
            return (
              <Button full onClick={pick}>
                upload an icon
              </Button>
            );
          }

          return (
            <Uploader file={file} onUploadSuccess2={this.handleUploadSuccess}>
              {({ progress, url }) => {
                if (progress === 100 && url) {
                  return this.renderPreview(url);
                } else {
                  return <Input disabled value="uploading ..." />;
                }
              }}
            </Uploader>
          );
        }}
      </Picker>
    );
  }
}

export default ContentSourceProviderProfilePictureInput;
